export default __webpack_public_path__ + "static/media/icon-eye-closed.65882223.svg";